module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Fork-61f20d6a9f21a21ca94dc779f0a4b92e.svg";